import { ref } from 'vue'

const areControlBarsCollapsed = ref(false)

function toggleControlBarsCollapse() {
  areControlBarsCollapsed.value = !areControlBarsCollapsed.value
}

function resetControlBarsCollapse() {
  areControlBarsCollapsed.value = false
}

export default function () {
  return {
    toggleControlBarsCollapse,
    areControlBarsCollapsed,
    resetControlBarsCollapse,
  }
}
